module.exports = __webpack_public_path__ + "img/natale2022banner.13c90801.jpg";